// extracted by mini-css-extract-plugin
export default {"background":"style_background__rFKVp","backgroundZoomed":"style_backgroundZoomed__Xf-Fr","container":"style_container__omKwH","image":"style_image__QMHBw"};